export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Hubungi <span className="text-orange-600">Kami</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Kami siap melayani kebutuhan material bangunan Anda dengan pelayanan terbaik
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Alamat</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    FQGW+JM4, Jl. Raya Pandeyan, Garen, Pandeyan,<br />
                    Kec. Ngemplak, Kabupaten Boyolali,<br />
                    Jawa Tengah 57375
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Telepon / WhatsApp</h3>
                  <a 
                    href="tel:+6285642080427"
                    className="text-sm text-gray-600 hover:text-orange-600 transition-colors"
                  >
                    085642080427
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Jam Operasional</h3>
                  <p className="text-sm text-gray-600">Senin - Sabtu: 07.00 - 17.00 WIB</p>
                  <p className="text-sm text-gray-600">Minggu: Tutup</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <a 
                href="https://wa.me/6285642080427"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-orange-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-orange-700 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap w-full justify-center"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Chat WhatsApp
              </a>
            </div>
          </div>

          <div className="relative h-96 w-full rounded-2xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3956.2!2d110.6469!3d-7.5234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zN8KwMzEnMjQuMiJTIDExMMKwMzgnNDguOCJF!5e0!3m2!1sid!2sid!4v1640000000000!5m2!1sid!2sid&q=FQGW%2BJM4%2C+Jl.+Raya+Pandeyan%2C+Garen%2C+Pandeyan%2C+Kec.+Ngemplak%2C+Kabupaten+Boyolali%2C+Jawa+Tengah+57375"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi Cobramas Production"
            ></iframe>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-xl p-8 text-center hover:bg-orange-50 transition-colors cursor-pointer border border-gray-100">
            <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Konsultasi Gratis</h3>
            <p className="text-sm text-gray-600">Tim kami siap membantu konsultasi kebutuhan material proyek Anda</p>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 text-center hover:bg-orange-50 transition-colors cursor-pointer border border-gray-100">
            <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-calculator-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Estimasi Harga</h3>
            <p className="text-sm text-gray-600">Dapatkan penawaran harga terbaik sesuai kebutuhan dan budget Anda</p>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 text-center hover:bg-orange-50 transition-colors cursor-pointer border border-gray-100">
            <div className="w-16 h-16 bg-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-truck-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Pengiriman Cepat</h3>
            <p className="text-sm text-gray-600">Pengiriman tepat waktu ke lokasi proyek Anda di Boyolali dan sekitarnya</p>
          </div>
        </div>
      </div>
    </section>
  );
}